/*
  GMDY: size picker in the bottom "Add to cart" bar on phones.
  See snippets/gmdy-sticky-size.liquid for what it does and when it is skipped.

  How it fits the theme:
  - The bar is Horizon's <sticky-add-to-cart>. Horizon rebuilds the bar's contents whenever the
    variant changes, so our two buttons are re-added by a MutationObserver. The "choose / chosen"
    state lives on the <sticky-add-to-cart> element itself, which Horizon keeps.
  - Picking a size sets the page's own size radio and fires "change", exactly like a tap on the
    size buttons, so Horizon updates price, stock, URL and the bar as usual. Setting the radio
    directly (instead of clicking its label) avoids the page jumping to the size buttons.
*/
(function () {
  'use strict';
  if (window.__gmdyStickySize) return;

  var dataEl = document.querySelector('script[data-gmdy-ss-data]');
  var host = document.querySelector('sticky-add-to-cart');
  if (!dataEl || !host) return;

  var data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  var productId = String(data.productId);
  var low = data.low || {};
  if (host.dataset.productId && host.dataset.productId !== productId) return;

  function picker() {
    return (
      document.querySelector('variant-picker[ref="mainVariantPicker"][data-product-id="' + productId + '"]') ||
      document.querySelector('variant-picker[data-product-id="' + productId + '"]')
    );
  }
  function sizeInputs() {
    var vp = picker();
    return vp ? Array.prototype.slice.call(vp.querySelectorAll('input[data-option-name="Size"]')) : [];
  }
  if (sizeInputs().length < 2) return;
  window.__gmdyStickySize = true;

  var phone = window.matchMedia('(max-width: 749px)');
  var chosen = new URLSearchParams(window.location.search).has('variant');
  var CHEVRON =
    '<svg viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M2 3.5 5 6.5 8 3.5"/></svg>';
  var CLOSE =
    '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M2 2l10 10M12 2 2 12"/></svg>';

  function currentSize() {
    var cur = sizeInputs().filter(function (i) { return i.checked; })[0];
    return cur ? cur.value : '';
  }

  /* ---------- the bar ---------- */
  function sizeLabel() {
    var s = currentSize();
    return chosen && s ? 'Size: ' + s : 'Size: Choose';
  }

  function renderBar() {
    var state = chosen ? 'chosen' : 'choose';
    if (host.getAttribute('data-gmdy-ss') !== state) host.setAttribute('data-gmdy-ss', state);

    var bar = host.querySelector('.sticky-add-to-cart__bar');
    if (!bar) return;
    var info = bar.querySelector('.sticky-add-to-cart__info');

    var sizeBtn = bar.querySelector('.gmdy-ss-size');
    if (!sizeBtn && info) {
      sizeBtn = document.createElement('button');
      sizeBtn.type = 'button';
      sizeBtn.className = 'gmdy-ss-size';
      sizeBtn.setAttribute('aria-haspopup', 'dialog');
      sizeBtn.innerHTML = '<span></span>' + CHEVRON;
      sizeBtn.addEventListener('click', openSheet);
      info.appendChild(sizeBtn);
    }
    if (sizeBtn) {
      var text = sizeLabel();
      var span = sizeBtn.querySelector('span');
      if (span && span.textContent !== text) span.textContent = text;
      var aria = chosen ? text + '. Change size' : 'Choose a size';
      if (sizeBtn.getAttribute('aria-label') !== aria) sizeBtn.setAttribute('aria-label', aria);
    }

    if (!bar.querySelector('.gmdy-ss-select')) {
      var selectBtn = document.createElement('button');
      selectBtn.type = 'button';
      selectBtn.className = 'button gmdy-ss-select';
      selectBtn.textContent = 'Select size';
      selectBtn.setAttribute('aria-haspopup', 'dialog');
      selectBtn.addEventListener('click', openSheet);
      bar.appendChild(selectBtn);
    }
  }

  renderBar();
  new MutationObserver(renderBar).observe(host, { childList: true, subtree: true, characterData: true });

  // A size tapped on the page itself (or picked in our sheet) counts as chosen.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!(t instanceof HTMLInputElement) || t.getAttribute('data-option-name') !== 'Size') return;
    var vp = picker();
    if (vp && vp.contains(t)) {
      chosen = true;
      renderBar();
    }
  });

  /* ---------- the sheet ---------- */
  var sheet = null;
  var backdrop = null;
  var opener = null;

  function buildSheet() {
    backdrop = document.createElement('div');
    backdrop.className = 'gmdy-sheet-backdrop';
    backdrop.addEventListener('click', closeSheet);

    sheet = document.createElement('div');
    sheet.className = 'gmdy-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-labelledby', 'gmdy-sheet-title');
    sheet.innerHTML =
      '<div class="gmdy-sheet__grab" aria-hidden="true"></div>' +
      '<div class="gmdy-sheet__head">' +
      '<p class="gmdy-sheet__title" id="gmdy-sheet-title">Select a size</p>' +
      '<button type="button" class="gmdy-sheet__close" aria-label="Close">' + CLOSE + '</button>' +
      '</div>' +
      '<p class="gmdy-sheet__product"></p>' +
      '<ul class="gmdy-sheet__sizes" role="list"></ul>' +
      '<div class="gmdy-sheet__foot"></div>';
    sheet.querySelector('.gmdy-sheet__close').addEventListener('click', closeSheet);
    sheet.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        closeSheet();
      } else if (e.key === 'Tab') {
        trapFocus(e);
      }
    });
    document.body.appendChild(sheet);
    document.body.appendChild(backdrop);
  }

  function trapFocus(e) {
    var items = Array.prototype.slice.call(
      sheet.querySelectorAll('button:not([aria-disabled="true"])')
    );
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function fillSheet() {
    var title = host.querySelector('.sticky-add-to-cart__title');
    var price = host.querySelector('.sticky-add-to-cart__price');
    var parts = [];
    if (title && title.textContent.trim()) parts.push(title.textContent.trim());
    if (price && price.textContent.trim()) parts.push(price.textContent.replace(/\s+/g, ' ').trim());
    sheet.querySelector('.gmdy-sheet__product').textContent = parts.join(' · ');

    var list = sheet.querySelector('.gmdy-sheet__sizes');
    list.innerHTML = '';
    sizeInputs().forEach(function (input) {
      var available = input.getAttribute('data-option-available') === 'true';
      var li = document.createElement('li');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gmdy-sheet__size';
      btn.textContent = input.value;
      btn.setAttribute('aria-pressed', chosen && input.checked ? 'true' : 'false');
      if (!available) {
        btn.setAttribute('aria-disabled', 'true');
        btn.setAttribute('aria-label', input.value + ', sold out');
      }
      btn.addEventListener('click', function () {
        if (!available) return;
        pickSize(input);
      });
      li.appendChild(btn);
      var left = low[input.getAttribute('data-variant-id')];
      if (available && left) {
        var note = document.createElement('span');
        note.className = 'gmdy-sheet__low';
        note.textContent = 'Only ' + left + ' left';
        li.appendChild(note);
      }
      list.appendChild(li);
    });

    var foot = sheet.querySelector('.gmdy-sheet__foot');
    foot.innerHTML = '';
    var fit = document.querySelector('.gsg-row__fit');
    if (fit) {
      var fitCopy = document.createElement('span');
      fitCopy.innerHTML = fit.innerHTML;
      foot.appendChild(fitCopy);
    }
    var guideTrigger = document.querySelector('[data-gsg-open]');
    if (guideTrigger) {
      var guide = document.createElement('button');
      guide.type = 'button';
      guide.className = 'gmdy-sheet__guide';
      guide.textContent = 'Size guide';
      guide.addEventListener('click', function () {
        guideTrigger.click();
        // The guide highlights the page's checked size. Until the shopper has chosen one,
        // that is only the theme's default, so don't mark it as "Selected".
        if (!chosen) {
          Array.prototype.forEach.call(document.querySelectorAll('dialog.gsg tr.is-current'), function (row) {
            row.classList.remove('is-current');
          });
        }
      });
      foot.appendChild(guide);
    }
    foot.hidden = !foot.childNodes.length;
  }

  function pickSize(input) {
    chosen = true;
    if (!input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    renderBar();
    closeSheet();
  }

  function openSheet(e) {
    if (!phone.matches) return;
    if (!sheet) buildSheet();
    opener = (e && e.currentTarget) || null;
    fillSheet();
    document.documentElement.setAttribute('data-gmdy-sheet-open', '');
    backdrop.setAttribute('data-open', '');
    sheet.setAttribute('data-open', '');
    var target =
      sheet.querySelector('.gmdy-sheet__size[aria-pressed="true"]') ||
      sheet.querySelector('.gmdy-sheet__size:not([aria-disabled="true"])') ||
      sheet.querySelector('.gmdy-sheet__close');
    if (target) target.focus({ preventScroll: true });
  }

  function closeSheet() {
    if (!sheet || !sheet.hasAttribute('data-open')) return;
    sheet.removeAttribute('data-open');
    backdrop.removeAttribute('data-open');
    document.documentElement.removeAttribute('data-gmdy-sheet-open');
    // Return focus to the bar: the button that opened the sheet if it is still shown, otherwise
    // Add to cart (the bar's buttons swap after a pick, and the theme may rebuild them).
    var candidates = [
      opener,
      host.querySelector('.sticky-add-to-cart__button'),
      host.querySelector('.gmdy-ss-select'),
      host.querySelector('.gmdy-ss-size')
    ];
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el && el.isConnected && el.getClientRects().length) {
        el.focus({ preventScroll: true });
        break;
      }
    }
    opener = null;
  }

  phone.addEventListener('change', function () {
    if (!phone.matches) closeSheet();
  });
})();
